import type { SVGProps } from 'react';
const SvgDialogsSidebar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <g clipPath="url(#dialogs-sidebar_svg__a)">
      <path
        fill="currentColor"
        fillOpacity={0.88}
        d="M7.143 8a.857.857 0 1 0 1.714 0 .857.857 0 0 0-1.714 0m3.571 0a.857.857 0 1 0 1.715 0 .857.857 0 0 0-1.715 0M3.572 8a.857.857 0 1 0 1.714 0 .857.857 0 0 0-1.714 0m11.807-3.1A8 8 0 0 0 8 0h-.036A7.98 7.98 0 0 0 0 8.038c.006 1.24.3 2.461.857 3.57v2.713a.82.82 0 0 0 .822.822h2.716a8 8 0 0 0 3.57.857h.037c1.07 0 2.107-.207 3.084-.613a7.9 7.9 0 0 0 2.55-1.7A7.98 7.98 0 0 0 16 8.035 8 8 0 0 0 15.38 4.9m-2.698 7.821A6.6 6.6 0 0 1 8 14.643H7.97a6.7 6.7 0 0 1-3.091-.777l-.15-.08H2.214V11.27l-.08-.15a6.67 6.67 0 0 1-.777-3.09A6.6 6.6 0 0 1 3.28 3.32a6.6 6.6 0 0 1 4.693-1.963h.03a6.6 6.6 0 0 1 4.7 1.945 6.6 6.6 0 0 1 1.944 4.728 6.62 6.62 0 0 1-1.966 4.691"
      />
    </g>
    <defs>
      <clipPath id="dialogs-sidebar_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDialogsSidebar;
